import { Entry } from 'contentful';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { Post } from 'repos/posts';

import ClockIcon from './svgs/clock';

type Props = {
  post: Entry<Post>;
};

export default function PostPreview({ post }: Props) {
  const { t } = useTranslation();

  return (
    <Link href={`/${post.fields.slug}`}>
      <a className="overflow-hidden rounded-xl bg-white shadow-2xl transition-transform hover:-translate-y-2">
        {/* <div className="font-bold text-gray-400">
          {post.fields.labels?.map((label) => label.fields.name).join(" | ")}
        </div> */}
        <div className="relative w-full pb-[66%]">
          <Image
            src={`https:${post.fields.image?.fields.file.url}?w=536&fit=fill&fm=webp`}
            alt={t('cover_image')}
            layout="fill"
            objectFit="cover"
            className="bg-gray-100"
          />
        </div>
        <div className="p-8">
          <h2 className="text-r-3xl mb-8 font-bold">{post.fields.title}</h2>
          <div className="flex items-center justify-between">
            {post.fields.author && (
              <div className="flex items-center">
                <div className="mr-3" style={{ fontSize: 0 }}>
                  <Image
                    src={`https:${post.fields.author.fields.image.fields.file.url}?w=40&h=40&fit=fill&f=face&fm=webp`}
                    alt="Author"
                    width={40}
                    height={40}
                    className="rounded-full bg-gray-200"
                  />
                </div>
                <span>
                  {post.fields.author.fields.firstName}{' '}
                  {post.fields.author.fields.lastName}
                </span>
              </div>
            )}
            <div className="flex items-center text-sm text-gray-500">
              <ClockIcon width={16} className="mr-2" />
              {t('x_min', { x: post.fields.readingTime })}
            </div>
          </div>
        </div>
      </a>
    </Link>
  );
}
